"use client";

import { Company, CompanyCard } from "@entities/employer";
import { EmptyScreen } from "@shared/cms";
import { Collection } from "@shared/types";
import { mapCollectionToPagination } from "@shared/utils";
import { SharedPagination, useIsMobile } from "@ubud-ui/react-ui-kit";
import { useRouter, useSearchParams } from "next/navigation";
import qs from "qs";
import { CompanyListGridConfig } from "../../types";

export function DefaultCompanyListGrid({ collection, config }: { collection: Collection<Company>; config: CompanyListGridConfig }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const isMobile = useIsMobile();

  const pagination = mapCollectionToPagination(collection);

  const handlePageChange = (page: number) => {
    const currentQuery = qs.parse(searchParams.toString());

    router.push(
      `/perusahaan?${qs.stringify(
        {
          ...currentQuery,
          page: page === pagination.lastPage ? pagination.lastPage : page + 1,
        },
        { skipNulls: true },
      )}`,
    );
  };

  return (
    <>
      {collection && collection.data && collection.data.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {collection.data.map((company) => {
            return <CompanyCard company={company} key={company.id} />;
          })}
        </div>
      ) : (
        <EmptyScreen {...config.emptyScreen} />
      )}
      {pagination.lastPage > 1 && (
        <div className="pt-10 sm:pt-14 flex justify-center">
          <SharedPagination
            pageToShow={5}
            currentPage={pagination.currentPage - 1}
            pageCount={pagination.lastPage}
            paginationType={isMobile ? "text" : "numeric"}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </>
  );
}
